import stockService from 'common/services/stockService'
import utils from 'utils'

export default class ovatBillModalCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, logger, Upload, $timeout, $rootScope, $uibModal, invoiceOpenService) {
        $scope.billInfo = {}
        $scope.billInfo.invType = '0'
        $scope.items = items1
        $scope.notFindDevice = true // 是否检测到开票点
        $scope.isOvatBill = true // 是否是在销售单页面
        if ($scope.items.code == 'OVAT_INVOICE_COMMON' || $scope.items.code == 'OVAT_INVOICE_ELE' || $scope.items.code == 'OVAT_INVOICE_VEHICLE' || $scope.items.code == 'OVAT_INVOICE_ROLL' || $scope.items.code == 'OVAT_RED_INFO' || $scope.items.code == 'OVAT_RED_INFO_DETAIL'|| $scope.items.code == 'OVAT_INVOICE_ALL_ELE' || $scope.items.code == 'OVAT_INVOICE_ALL_ELE_SPEC') {
            $scope.isOvatBill = false
            $scope.billInfo.invoiceAuto = true
        }
        $scope.$watch('billInfo.invoiceAuto', () => {
            if (!$scope.billInfo.invoiceAuto) $scope.billInfo.autoMerge = false
        })
        httpRequest.get_dictByTypeArr(['inv_type']).then((res) => {
            $scope.dictData = res.data.value['inv_type']
            if ($scope.items.code == 'TXT') {
                $scope.dictData.splice(2, 1)
                $scope.dictData = $scope.dictData.slice(0, 3)
            }
        })
        $scope.invoiceRemainList = [{
            invoiceType: '2',
            remain: 0,
        }, {
            invoiceType: '0',
            remain: 0,
        }, {
            invoiceType: '51',
            remain: 0,
        }, {
            invoiceType: '12',
            remain: 0,
        }, {
            invoiceType: '41',
            remain: 0,
        }]
        if ($scope.items.code == 'OVAT_INVOICE_COMMON') $scope.invoiceRemainList.splice(2)
        if ($scope.items.code == 'OVAT_BILL') $scope.invoiceRemainList.splice(3)
        if ($scope.items.code == 'OVAT_INVOICE_VEHICLE' || $scope.items.code == 'OVAT_VEHICLE_BILL') $scope.invoiceRemainList = [$scope.invoiceRemainList[3]]
        if ($scope.items.code == 'OVAT_INVOICE_ELE') $scope.invoiceRemainList = [$scope.invoiceRemainList[2]]
        if ($scope.items.code == 'OVAT_INVOICE_ROLL' || $scope.items.code == 'OVAT_ROLL_BILL') $scope.invoiceRemainList.splice(0, 4)
        if ($scope.items.code == 'OVAT_RED_INFO' || $scope.items.code == 'OVAT_RED_INFO_DETAIL' || $scope.items.code == "redBatchOpen") $scope.invoiceRemainList = [$scope.invoiceRemainList[1]]


        // 带搜索功能的下拉选择框相关方法
        function toSelect2data(list, idfield, textfield) {
            const result = []
            for (const a in list) {
                const tempdata = {
                    id: '',
                    text: '',
                }
                $.extend(tempdata, list[a])
                tempdata.id = list[a][idfield]
                tempdata.text = list[a][textfield]
                result.push(tempdata)
            }
            return result
        }
        $scope.config2 = {}
        $scope.aS2 = {}
        if($scope.items.code == 'OVAT_INVOICE_ALL_ELE' || $scope.items.code == 'OVAT_INVOICE_ALL_ELE_SPEC'){
            $scope.ukeyList = JSON.parse(localStorage.user_info).tax4UkeyList
        }else {
            $scope.ukeyList = JSON.parse(localStorage.user_info).tax3UkeyList
        }
        $scope.billInfo.ukeyId = $scope.billInfo.ukeyId ? $scope.billInfo.ukeyId : $scope.ukeyList[0].ukeyId
        $scope.aS2.ukeyId = $scope.ukeyList.length ? $scope.ukeyList[0].ukeyId : ''
        $scope.config2.data = toSelect2data($scope.ukeyList, 'ukeyId', 'ukeyName')
        const _config = {
            code: 'UKEY',
            typeCode: items1.code,
            validate: {
                pattern: '.xlsx,.xls,.txt',
                _validate: {
                    size: {
                        min: 10,
                        max: '10MB',
                    },
                    duration: {
                        min: '10s',
                        max: '5m',
                    },
                    accept: '.xlsx,.xls,.xml,.txt',
                },
            },
            callback() { },
        }
        $scope.uploadFiles = async function (file, errFiles) {
             const ukeyData = $scope.ukeyList.filter((ele) => {
                return ele.ukeyId == $scope.billInfo.ukeyId
            })
            let loginStatus = 1
            if(($scope.items.code == 'OVAT_INVOICE_ALL_ELE' || $scope.items.code == 'OVAT_INVOICE_ALL_ELE_SPEC')&& ukeyData[0].manageType!='7'){
               await httpRequest.post_queryDrawerByUkeyIds($scope.billInfo.ukeyId).then((res) => {
                    //loginStatus 1登录成功  0未登录
                    loginStatus = res.data[0]?res.data[0].loginStatus:0
                })
            }
            if(loginStatus == '0'){
                logger.logError('对应开票员未登录，请先到实名认证界面进行登录操作。')
                return
            }
            // 不符合文件格式的错误提示
            if ($scope.aS2 == null) {
                logger.logError('请选择开票点')
                return
            }
            if ($scope.aS2.ukeyId == '') {
                logger.logError('请选择开票点')
                return
            }

            if (file == null && errFiles.length >= 1) {
                if (!$scope.isOvatBill) {
                    logger.logError('文件类型错误，文件大小不超过5MB，只支持.xlsx,.xls格式文件导入')
                } else {
                    logger.logError('文件类型错误，文件大小不超过10MB，只支持.xlsx,.xls,. txt格式文件导入')
                }
                return
            }
            if (file) {
                const data = {
                    importFile: file,
                    ukeyId: $scope.aS2.ukeyId,
                    typeCode: $scope.items.code,
                    invoiceAuto: $scope.billInfo.invoiceAuto ? '1' : '0',
                    autoMerge: $scope.billInfo.autoMerge ? '1' : '0',
                }
                if (items1.code == 'TXT') {
                    switch ($scope.billInfo.invType) {
                        case '0':
                            data.typeCode = 'OVAT_BILL_TXT_VAT'
                            break;
                        case '2':
                            data.typeCode = 'OVAT_BILL_TXT_COMMON'
                            break;
                        case '51':
                            data.typeCode = 'OVAT_BILL_TXT_ELE'
                            break;
                        default:
                            break;
                    }
                }
                file.upload = Upload.upload({
                    url: `${host.etcloudOvat}dlTaskService/importBill`,
                    data
                })
                // 文件上传
                // loading动画
                const importinglayer = layer.msg('玩命上传中，请耐心等待', {
                    time: 0,
                    skin: 'layer-loading-self',
                    icon: 16,
                    shade: 0.5,
                })
                file.upload.then((response) => {
                    $timeout(() => {
                        if (!response.data.success) {
                            // 关闭loading
                            layer.close(importinglayer)
                            return logger.logError(response.data.message || '上传失败')
                        }
                        file.result = response.data
                        const {
                            batchNo
                        } = file.result.value
                        const {
                            sourceCount
                        } = file.result.value
                        const {
                            errorCount
                        } = file.result.value
                        const {
                            successKeyCount
                        } = file.result.value
                        const {
                            reamrk
                        } = file.result.value
                        const _req = {
                            pageNum: 1,
                            pageSize: 10,
                            param: batchNo,
                        }
                        $uibModalInstance.close(_req)
                        // 请求错误信息
                        httpRequest.post_getPageDlBatchInfoList(_req).then((res) => {
                            // 关闭loading
                            layer.close(importinglayer)
                            // 获取导出信息详细数据
                            const goodsImportRes = res.data.value
                            const modalData = { // 返回给弹窗的数据
                                queryOvatBillList: $scope.items.queryOvatBillList,
                                idToken: $rootScope.idToken,
                                params: {
                                    batchNo,
                                    sourceCount,
                                    successCount: sourceCount - errorCount,
                                    errorCount,
                                    data: goodsImportRes,
                                    successKeyCount,
                                    reamrk,
                                },
                                isOvatBill: $scope.isOvatBill,
                                isOvatRedBill: $scope.items.code == 'OVAT_RED_INFO' || $scope.items.code == 'OVAT_RED_INFO_DETAIL',
                            }
                            // 弹窗实例
                            const modalInstance = $uibModal.open({
                                templateUrl: './app/outputManage/fillOpenManage/ovatBill/view/importOvatBillModalContentCtrl.html',
                                controller: 'importOvatBillModalContentCtrl',
                                backdrop: 'static',
                                openedClass: 'mod-modal-importexcel mod-modal mod-modal-lg',
                                windowClass: 'mod-modal mod-modal-lg',
                                bindToController: true,
                                resolve: {
                                    items1() {
                                        return modalData
                                    },
                                },
                            })
                            // 弹窗回掉
                            modalInstance.result.then((selectedItem) => {
                                _config.callback && _config.callback()
                            }, () => {
                                console.log(`Modal dismissed at: ${new Date()}`)
                                _config.callback && _config.callback()
                            })
                        })
                    })
                }, (response) => {
                    if (response.status > 0) {
                        // 关闭loading
                        layer.close(importinglayer)
                        logger.logError('上传失败 ')
                    }
                }, (evt) => {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total))
                    console.log(file.progress)
                })
            }
        }
        $scope.download = function () {
            window.open(`${host.etcloudOvat}dlTaskService/export_${$scope.items.code}?accessToken=${localStorage.id_token}`)
        }
        $scope.ok = function () { }
        $scope.next = function () {
            $uibModalInstance.close($scope.billInfo.ukeyId)
        }
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
        // 监听开票点变化
        $scope.$watch('billInfo.ukeyId', async (newVal) => {
            if (items1.code == 'TXT') return
            const ukey = $scope.config2.data.filter((conf) => conf.id === Number(newVal))[0]
            invoiceOpenService.getStockByUkey(
                $scope.userInfo.sysUkeyList,
                ukey.ukeyId,
            ).then(arr => {
                console.log(arr)
                $scope.invoiceRemainList.forEach(i => {
                    arr.forEach(o => {
                        if (o.invType == i.invoiceType) {
                            i.remain = o.sum
                            i.invoiceCode = o.invoiceCode
                            i.invoiceNumber = o.invoiceNumber
                        }
                    })
                    $scope.notFindDevice = false
                }, () => {
                    $scope.notFindDevice = true
                })
            }, () => {
                $scope.notFindDevice = true
            })
        })
        //数据采集 确定按钮
        $scope.collectData = function () {
            if (!$scope.billInfo.ukeyId) {
                logger.logError("请选择开票点")
                return
            }
            $uibModalInstance.close($scope.billInfo)
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/ovatBill/ovatBillModalCtrl.js